//#region types
import { FormEnums } from "models/enums";
import { BenefitFormTypes } from "models/formTypes";
import { AutoCompleteExtraProps, GenericFormSection } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
//#endregion
//#region components
import { useWintSalaryService } from "serviceHooks";
import useBenefitTypesHelper from "./forms/useBenefitTypesHelper";
import { useDeviationPermissions } from "components/salaryDeviation";
//#endregion
import { QueryStateHelper } from "utils/helpers";

function useBenefitReportFilterDefinition() {
  const { searchPersonsAutoComplete } = useWintSalaryService();
  const { benefitTypes, groupSelections } = useBenefitTypesHelper();

  const { canManageSalary, isSalaryAdmin, isBusinessUnitManagerWithSalaryRights, isDeviationAdmin } =
    useDeviationPermissions();

  const filterFormFields: GenericFormSection<BenefitFormTypes.Filter>[] = [
    {
      label: TranslationKeys.Common.General,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: {
        monthRange: {
          label: TranslationKeys.Common.TimePeriod,
          type: FormEnums.FormFieldType.MONTHRANGE,
        },
        persons: {
          label: TranslationKeys.Common.Employee,
          type: FormEnums.FormFieldType.MULTIPLEAUTOCOMPLETE,
          extraProps: {
            items: (searchStr: string) =>
              searchPersonsAutoComplete(
                searchStr,
                false,
                true,
                isBusinessUnitManagerWithSalaryRights && !(isSalaryAdmin || isDeviationAdmin)
              ),
          } as AutoCompleteExtraProps<BenefitFormTypes.Filter>,
          hidden: !canManageSalary,
        },
        benefitTypes: {
          label: TranslationKeys.Benefit.BenefitTypeLabel,
          type: FormEnums.FormFieldType.MULTIPLEAUTOCOMPLETE,
          extraProps: {
            items: benefitTypes,
          } as AutoCompleteExtraProps<BenefitFormTypes.Filter>,
        },
        groupSelection: {
          label: TranslationKeys.Benefit.GroupSelectionLabel,
          type: FormEnums.FormFieldType.SELECTION,
          extraProps: {
            items: groupSelections,
          },
        },
      },
    },
  ];

  const filterQueryStateHandler: FilterQueryStateHandler<BenefitFormTypes.Filter> = {
    monthRange: QueryStateHelper.monthRangeQueryEncoder(FormFieldConstants.Benefits.Filter.MonthRange),
    persons: QueryStateHelper.multipleAutoCompleteItemsQueryEncoder(FormFieldConstants.Benefits.Filter.Persons),
    benefitTypes: QueryStateHelper.multipleAutoCompleteItemsQueryEncoder(
      FormFieldConstants.Benefits.Filter.BenefitTypes
    ),
    groupSelection: QueryStateHelper.numberQueryEncoder(FormFieldConstants.Benefits.Filter.GroupSelection),
  };

  return {
    filterFormFields,
    filterQueryStateHandler,
  };
}

export default useBenefitReportFilterDefinition;
